import { render, staticRenderFns } from "./JSBeforeYouContinue.vue?vue&type=template&id=63b02ac6&scoped=true&"
import script from "./JSBeforeYouContinue.vue?vue&type=script&lang=js&"
export * from "./JSBeforeYouContinue.vue?vue&type=script&lang=js&"
import style0 from "./JSBeforeYouContinue.vue?vue&type=style&index=0&id=63b02ac6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b02ac6",
  null
  
)

export default component.exports